<template>
  <div>
    <div class="pay-qa-box">
      <div class="qa-box pointer" @click="handleGotoQa">
        <!-- <img src="@/assets/img/global/icon_qa.png" /> -->
        문의하기
      </div>
      <div v-if="chkMain" class="pay-box pointer" @click="clickMore('https://carrotenglish.kr/phone/register_payment_global')">
        <!-- <img src="@/assets/img/global/icon_pay.png" /> -->
        결제하기
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CarrotSolutionsContactUs",

  data() {
    return {
      chkMain: false,
    };
  },
  created() {
    this.chkMain = !window.location.href.includes("sub");
  },
  mounted() {
    // this.chkMain = window.location.href
  },

  methods: {
    clickMore(path) {
      window.open(path, "_blank");
    },
    handleGotoQa() {
      if ((this.chkMain = false)) {
        document.getElementById("section_qa").scrollIntoView({ behavior: "smooth" });
        window.location.href = "/global#section_qa";
      }
      if ((this.chkMain = true)) {
        window.location.href = "/global#section_qa";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.pay-qa-box {
  top: 85%;
  right: 4%;
  z-index: 10;
  display: flex;
  position: fixed;
  flex-direction: column;

  .qa-box {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #ff5f07;
    padding: 10px 23px;
    font-size: 14px;
    color: #ffffff;
    box-shadow: 0px 33px 55px 0 rgba(0, 0, 0, 0.13);
    margin-bottom: 10px;

    img {
      width: 24px;
    }
  }

  .pay-box {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #ffffff;
    padding: 10px 23px;
    font-size: 14px;

    img {
      width: 24px;
    }
  }
}
</style>
